module.exports = __webpack_public_path__ + "static/img/applicableScene8.5b19403.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applicableScene8.png
// module id = 9qwB
// module chunks = 0